import { Component, OnInit, Input, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { ActividadesService } from '../../../providers/actividades.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { WMatTimePickerComponent } from '../../timer/time-control';
import { Usuario, TipoUsuario } from '../../../interfaces/usuario';
import { UsuarioService } from '../../../providers/usuario.service';
import { Telefono } from '../../telefono/telefono.component';
import { TareaService } from '../../../providers/tarea.service';


export interface DialogData {
  accion: any;
  actividad: any;
}
@Component({
  selector: 'app-ver-actividades',
  templateUrl: './ver-actividades.component.html',
  styleUrls: ['./ver-actividades.component.scss']
})
export class VerActividadesComponent implements OnInit {

  cargando: boolean = true;
  public listadoActividades = [];
  public idUsuario:any;
  public asingUsu:boolean = false;
  @Input() itemData: number;
  @Input() pagina: 'persona' | 'cotizacion' | '' = '';
  @Input() propuesta: any;
  @Input() entidad: any;
  @Input() cotizacion: any;
  @Input() agenda: any;
  @Input() soloTareas: any;
  @Output() onActualizado = new EventEmitter();
  @Input() newActivities: any[];


  constructor(
    private actividadesService: ActividadesService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
  ) { }
  ngOnChanges(changes: any) {
    console.log('Pase por changes');
    this.traerActividades(this.itemData);
  }
  ngOnInit() {
    console.log('Pase por init');
    // this.traerActividades(this.itemData);
  }

  traerActividades(id?): void {
    this.cargando = true;
    this.listadoActividades = [];
    var filtros = {};

    if (this.propuesta != undefined) {
      Object.assign(filtros, {
        IdPropuesta: id
      });
    } else if (this.cotizacion != undefined) {
      Object.assign(filtros, {
        IdCotizacion: id
      });
    } else if (this.agenda) {
      Object.assign(filtros, {
        TareaFecha: this.agenda
      });
    } else {
      Object.assign(filtros, {
        IdPersona: id
      });
    }

    if (this.soloTareas != undefined) {
      Object.assign(filtros, {
        soloTareas: 1
      });
    }

    this.actividadesService.getActividades(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      filtros
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          
          let datosUsuario = JSON.parse(localStorage.getItem('currentUser'));
          this.idUsuario = datosUsuario.IdUsuario;
          console.log('Aaca es la la lista de actividades', respuesta);
          this.listadoActividades = respuesta.data.actividades;
        }
        this.cargando = false;
        this.onActualizado.emit();
      },
      () => {

      },
      () => {

      }

    );
  }
  marcarActividad(actividad: any){
    return actividad.responsables.some(responsable => responsable.usuario.IdUsuario == this.idUsuario);
  }

  openDialog(actividad?, accion?): void {
    const dialogRef = this.dialog.open(DialogEditarActividad, {
      width: '30vw',
      data: { actividad, accion }
    });

    dialogRef.afterClosed().subscribe(resultado => {
      if (resultado == 'reload') {
        console.log('Pase por dialog');
        // this.traerActividades(this.itemData);
      }
    });
  }

  obtenerHoraString(fecha) {
    let hora = fecha.split(' ')[1];
    return hora;
  }

  sincronizarActividad(actividad) {


    let fecha = actividad.fechaTarea;
    fecha = fecha.substring(0, 10);
    fecha = fecha.replaceAll('-', '');

    let hora = this.obtenerHoraString(actividad.fechaTarea);
    hora = hora.replaceAll(':', '');

    // Crear un objeto de fecha con la fecha y hora de la actividad
    let fechaActividad = new Date(`${fecha.substring(0, 4)}-${fecha.substring(4, 6)}-${fecha.substring(6, 8)}T${hora.substring(0, 2)}:${hora.substring(2, 4)}:${hora.substring(4, 6)}`);

    // Convertir la fecha a UTC
    let fechaUTC = fechaActividad.toISOString().replace(/[-:.]/g, "").substring(0, 15) + "Z";

    // Crear una nueva fecha para la fecha de finalización que es una hora después de la fecha de inicio
    let fechaFin = new Date(fechaActividad.getTime() + 60 * 60 * 1000);
    let fechaFinUTC = fechaFin.toISOString().replace(/[-:.]/g, "").substring(0, 15) + "Z";

    let text = actividad.titulo;
    let dates = fechaUTC + "/" + fechaFinUTC;

    let details = actividad.descripcion;
    let location = "Argentina";

    let link = "https://www.google.com/calendar/render?action=TEMPLATE&text=" + text + "&dates=" + dates + "&details=" + details + "&location=" + location + "&sf=true&output=xml";

    window.open(link, '_blank');

  }

}

@Component({
  selector: 'dialog-editar-actividad',
  templateUrl: 'dialog-editar-actividad.html',
})

export class DialogEditarActividad {

  form = this._formBuilder.group({
    id: [],
    titulo: [],
    fechaTarea: [],
    horaTarea: [],
    fechaNotificacion: [],
    descripcion: [],
    cotizacion: [],
    entidad: [],
    propuesta: [],
    responsables: [],
  });
  error: string = '';
  public actividades: any;
  cargando: boolean = false;
  horaActividad;
  horaNotificacion;
  @ViewChild('horaActividadInput') horaActividadInput: WMatTimePickerComponent;
  @ViewChild('horaNotificacionInput') horaNotificacionInput: WMatTimePickerComponent;
  usuarios: any = [];
  // usuarios: Usuario[] = [];

  constructor(
    private dialogRef: MatDialogRef<DialogEditarActividad>,
    private _formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private _actividadesSv: ActividadesService,
    private _tareaSv: TareaService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private usuarioService: UsuarioService
  ) { }


  onNoClick(): void {
    this.dialogRef.close('prueba cerrar');
  }

  traerResposables() {
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }
        // console.log(this.usuarios);
        // console.log(this.form.controls['responsables'].value);
      });
  }

  // submitEditar() {
  //   this.dialogRef.close(this.form.getRawValue());
  // }

  submitEditar() {
    this.error = '';
    try {
      this.actividades = {
        "actividad": this.form.getRawValue()
      }
      if (typeof this.actividades.actividad.fechaTarea != 'string') {
        this.actividades.actividad.fechaTarea = this.actividades.actividad.fechaTarea.format("YYYY-MM-DD") + ' ' + this.horaActividad;
      } else {
        this.actividades.actividad.fechaTarea = this.actividades.actividad.fechaTarea + ' ' + this.horaActividad;
      }
      if (this.actividades.actividad.fechaNotificacion != '' && typeof this.actividades.actividad.fechaNotificacion != 'string') {
        this.actividades.actividad.fechaNotificacion = this.actividades.actividad.fechaNotificacion.format("YYYY-MM-DD") + ' ' + this.horaNotificacion;
      } else if (this.actividades.actividad.fechaNotificacion != '' && typeof this.actividades.actividad.fechaNotificacion == 'string') {
        this.actividades.actividad.fechaNotificacion = this.actividades.actividad.fechaNotificacion + ' ' + this.horaNotificacion;
      }
      if (this.form.valid) {
        this.cargando = true;
        this._actividadesSv.editarActividad(this.actividades).subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.dialogRef.close('reload');
            } else {
              this.cargando = false;
              this.error = respuesta.mensaje;
            }

          },
          error => {
            this.cargando = false;
            this.error = error;
          });
      }
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }
  eliminar() {
    this.error = '';
    try {
      this.actividades = {
        "IdTarea": this.form.controls['id'].value
      }


      if (this.form.valid) {
        this.cargando = true;
        this._tareaSv.eliminarTarea(this.actividades).subscribe(
          respuesta => {
            if (respuesta.estado == 1) {
              this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
              this.dialogRef.close('reload');
            } else {
              this.cargando = false;
              this.error = respuesta.mensaje;
            }

          },
          error => {
            this.cargando = false;
            this.error = error;
          });
      }
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }

  ngOnInit() {
    this.traerResposables();
    let actividadFechaHora = this.data['actividad']['fechaTarea'].split(' ');
    let notificacionFechaHora = ['', ''];
    if (this.data['actividad']['fechaNotificacion'] != undefined) {
      notificacionFechaHora = this.data['actividad']['fechaNotificacion'].split(' ');
    }
    this.form.controls['id'].setValue(this.data['actividad']['id']);
    console.log('Aca lo que busco?: ', this.data['actividad']['id']);
    this.form.controls['titulo'].setValue(this.data['actividad']['titulo']);
    this.form.controls['fechaTarea'].setValue(actividadFechaHora[0]);
    this.form.controls['fechaNotificacion'].setValue(notificacionFechaHora[0]);
    this.horaActividad = actividadFechaHora[1];
    this.horaNotificacion = notificacionFechaHora[1];
    // this.form.controls['horaActividad'].setValue(actividadFechaHora[1]);
    // this.form.controls['horaNotificacion'].setValue(notificacionFechaHora[1]);
    this.form.controls['descripcion'].setValue(this.data['actividad']['descripcion']);
    this.form.controls['propuesta'].setValue(this.data['actividad']['propuesta']);
    this.form.controls['entidad'].setValue(this.data['actividad']['entidad']);
    this.form.controls['cotizacion'].setValue(this.data['actividad']['cotizacion']);
    // this.form.controls['responsables'].setValue(this.data['actividad']['responsables']);
    let responsables = [];
    this.data['actividad']['responsables'].forEach(responsable => {
      responsables.push(responsable.usuario);
    });
    this.form.controls['responsables'].setValue(responsables);

  }
}
